import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Arrow Left Icon',
};

export const ArrowLeftIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.53721 10.8142L9.86565 15.1426C10.1837 15.4606 10.1837 15.9762 9.86566 16.2942C9.54766 16.6122 9.03208 16.6122 8.71408 16.2942L2.99562 10.5758C2.84291 10.4231 2.75712 10.216 2.75712 10C2.75712 9.78408 2.84291 9.57696 2.99562 9.42425L8.71408 3.7058C9.03208 3.3878 9.54766 3.3878 9.86566 3.7058C10.1837 4.0238 10.1837 4.53938 9.86566 4.85738L5.53735 9.18567L16.4286 9.18567C16.8783 9.18567 17.2429 9.55024 17.2429 9.99996C17.2429 10.4497 16.8783 10.8142 16.4286 10.8142L5.53721 10.8142Z"
            />
        </SvgIcon>
    );
};
